module.exports = __webpack_public_path__ + "media/images/AndrosLogo_main-positive-277bbb4fb570e7705aad0b88fc637ef9.png";